import type { LayoutLoad } from './$types';
import EppoVariant from '$lib/storyblok/blocks/eppoVariant.svelte';
import GeolocationBlock from '$lib/storyblok/blocks/geolocationBlock.svelte';
import SiteBanner from '$lib/storyblok/blocks/siteBanner.svelte';
import PageFilter from '$lib/storyblok/blocks/pageFilter.svelte';
import { registerComponents } from '$lib/storyblok/sdk';
import { initDatadog } from '$lib/utils/datadog';
import { browser, dev } from '$app/environment';
import { geolocation as geolocationState } from '$lib/state/geolocation.svelte';
import { initAnalytics, trackPage } from '$lib/segment/client';
import { device } from '$lib/state/device.svelte';
import { tiktokPageView } from '$lib/utils/tiktok';
import { trackJm } from '$lib/utils/juiceMedia';
import { trackPodsights } from '$lib/utils/podsights';
import { checkoutSession } from '$lib/state/checkoutSession.svelte';
import { storyblok } from '$lib/state/storyblok.svelte';
import ActiveProductWrapper from '$lib/storyblok/blocks/productSelect/activeProductWrapper.svelte';
import { pushToDataLayer } from '$lib/utils/gtm';

if (!dev) {
	initDatadog();
}

registerComponents({
	eppo_variant: EppoVariant,
	email_capture_modal: import('$lib/storyblok/blocks/emailCaptureModal.svelte'),
	email_capture_modal_v2: import('$lib/storyblok/blocks/emailCaptureModalV2.svelte'),
	geolocation_block: GeolocationBlock,
	page_filter: PageFilter,
	quiz_modal: import('$lib/storyblok/blocks/quiz/quizModal.svelte'),
	site_banner: SiteBanner,
	single_step_quiz: import('$lib/storyblok/blocks/quiz/singleStepQuiz.svelte'),
	quiz_step_single_select: import('$lib/storyblok/blocks/quiz/quizStepSingleSelect.svelte'),
	quiz_step_single_select_answer: import(
		'$lib/storyblok/blocks/quiz/quizStepSingleSelectAnswer.svelte'
	),
	quiz_step_submit_email: import('$lib/storyblok/blocks/quiz/quizStepSubmitEmail.svelte'),
	quiz_single_step_result: import('$lib/storyblok/blocks/quiz/quizSingleStepResult.svelte'),
	quiz_single_step_result_option: import(
		'$lib/storyblok/blocks/quiz/quizSingleStepResultOption.svelte'
	),
	quiz_coupon_code_result: import('$lib/storyblok/blocks/quiz/quizCouponCodeResult.svelte'),
	quiz_coupon_code_result_option: import(
		'$lib/storyblok/blocks/quiz/quizCouponCodeResultOption.svelte'
	),
	active_product_wrapper: ActiveProductWrapper
});

export const load: LayoutLoad = async ({
	data: {
		sbAccessToken,
		geolocation,
		deviceData,
		hasFreeShipping,
		anonymousId,
		sbEditMode,
		og_metadata
	},
	url
}) => {
	storyblok.init({ accessToken: sbAccessToken, editMode: sbEditMode, url });
	geolocationState.data = geolocation;
	device.data = deviceData;

	if (browser) {
		if (hasFreeShipping) {
			await checkoutSession.configure({
				shippingId: undefined
			});
		}

		initAnalytics(anonymousId);

		pushToDataLayer({
			geolocation: {
				city: geolocation.city,
				state: geolocation.region,
				commuting_zone_id: geolocation.commuting_zone_id ?? undefined
			}
		});

		trackPage(url);
		tiktokPageView();
		trackJm('page_view');
		trackPodsights('view');
	}

	return { og_metadata };
};
